import React from 'react';
import StatisticTableHead from "./StatisticTableHead";
import StatisticTableRow from "./StatisticTableRow";
import {Table, Tr} from "../StatisticDesign";

const StatisticTable = ({Dates, selectedHouse, Data}) => {
    return (
        <Table>
            {
                <StatisticTableHead
                    Dates={Dates}
                />
            }
            {
                Data?
                    <StatisticTableRow
                        Floors={Data[selectedHouse]}
                        Dates={Dates}
                    />
                    :""
            }
        </Table>
    );
};

export default StatisticTable;